<template>
  <div class="hotelRoomOverview">
    <h3 class="hotelRoomName">{{ roomTypeName }}</h3>
    <ul class="hotelRoomOverviewList">
      <li>
        <tk-svg-icon class="icoPeople" icon="people" />
        {{ maxGuestNumber ? `定員1~${maxGuestNumber}名` : noInforMessage }}
      </li>
      <li>
        <tk-svg-icon class="icoSize" icon="size" />
        {{ area ? `${area} 平米` : noInforMessage }}
      </li>
      <li>
        <tk-svg-icon class="icoBed" icon="bed2" />
        {{ bedType }}
      </li>
    </ul>
    <div class="hotelRoomOverviewBox">
      <p v-if="leftRoomNumber <= 3" class="roomVacansyEmpty">
        あと{{ leftRoomNumber }}室
      </p>
      <p>
        <tk-link class="hotelBtnMini" @click="showDetail = true">
          客室の詳細
        </tk-link>
      </p>
      <p v-if="noSmoking" class="roomSmokeRabel">
        <tk-svg-icon class="icoNosmoke" icon="nosmoke" />
      </p>
    </div>

    <room-type-detail-modal
      v-if="showDetail"
      :no-smoking="noSmoking"
      :room-type-name="roomTypeName"
      :introduction="introduction"
      :area="area"
      :bed-type="bedType"
      :bed-type-info="bedTypeInfo"
      :wifi="wifi"
      :bath-room="bathRoom"
      :amenity="amenity"
      :accommodation-children="accommodationChildren"
      :barrier-free="barrierFree"
      :note="note"
      :max-guest-number="maxGuestNumber"
      :image-list="imageList"
      @close="showDetail = false"
    />
  </div>
</template>

<script>
import TkLink from '../../atoms/TkLink/TkLink'
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'
import RoomTypeDetailModal from './RoomTypeDetailModal.vue'

export default {
  name: 'RoomTypeInfo',
  components: {
    TkLink,
    RoomTypeDetailModal,
    TkSvgIcon,
  },
  props: {
    roomTypeName: {
      type: String,
      default: '',
    },
    maxGuestNumber: {
      type: Number,
      required: true,
    },
    area: {
      type: Number,
      required: true,
    },
    leftRoomNumber: {
      type: Number,
      default: 0,
    },
    bedType: {
      type: String,
      required: true,
    },
    bedTypeInfo: {
      type: String,
      default: '',
    },
    noSmoking: {
      type: Boolean,
      default: false,
    },
    imageList: {
      type: Array,
      default() {
        return []
      },
    },
    introduction: {
      type: String,
      default: '',
    },
    wifi: {
      type: String,
      default: '',
    },
    bathRoom: {
      type: String,
      default: '',
    },
    amenity: {
      type: String,
      default: '',
    },
    accommodationChildren: {
      type: String,
      default: '',
    },
    barrierFree: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDetail: false,
      noInforMessage: '情報なし',
    }
  },
}
</script>
